import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayPcHeaderBarComponent} from "../../game-play-pc-header-bar.component";
import React from "react";
import {
    GamePlayPcHeaderBarTopLeftStartSectionBox
} from "../../boxes/sections/top-section/left/game-play-pc-header-bar-top-left-start-section.box";
import {GamePcHeaderBarClockComponent} from "../../../../common/parts/clock/game-pc-header-bar-clock.component";
import {BlankHorizontalSeparatorBox} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    GamePlayPcHeaderBarTopLeftSectionComponent
} from "../../parts/sections/top-section/left/game-play-pc-header-bar-top-left-section.component";
import {
    OntarioResponsibleGamingButtonsComponent
} from "../../../../../../responsible-gambling/responsible-gaming-buttons/regulations/ontario/ontario.responsible-gaming-buttons.component";

interface OntarioGamePlayPcHeaderBarComponentProps {
    gameContext: IGameContextViewModel
}

export const OntarioGamePlayPcHeaderBarComponent = observer(
    class OntarioGamePlayPcHeaderBarComponent extends OrbitComponent<OntarioGamePlayPcHeaderBarComponentProps> {

        private _renderTopLeftStartSection = () => {
            return (
                <GamePlayPcHeaderBarTopLeftStartSectionBox>
                    <GamePcHeaderBarClockComponent/>
                    <BlankHorizontalSeparatorBox/>
                    <OntarioResponsibleGamingButtonsComponent/>
                    <BlankHorizontalSeparatorBox/>
                </GamePlayPcHeaderBarTopLeftStartSectionBox>
            )
        }

        private _renderTopLeftSection = () => {
            return (
                <GamePlayPcHeaderBarTopLeftSectionComponent gameContext={this.props.gameContext}
                                                            renderStartSection={this._renderTopLeftStartSection}/>
            )
        }

        render() {
            return (
                <GamePlayPcHeaderBarComponent gameContext={this.props.gameContext}
                                              renderTopLeftSection={this._renderTopLeftSection}/>
            )
        }
    }
);